import { Grid, Typography } from '@mui/material';
import ComparisonChart from '../../components/comparision-chart';

const Charts = () => {
  return (
    <>
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: 700,
          color: '#111827',
          letterSpacing: '0.5px',
          // textAlign: { xs: 'left', sm: 'center', md: 'center' },
        }}
      >
        نمودار‌ها
      </Typography>
      <Grid
        item
        xs={12}
        pr={'0 !important'}
        mt={{
          xs: '20px',
        }}
        pt={'0 !important'}
      >
        <ComparisonChart
          sources={['SERVAT_TOKENIKO', 'SERVAT_NARIN', 'ESTJ']}
          title="نمودار نارین, توکنیکو و اتحادیه"
          defaultWeight="BULLION_10"
        />
      </Grid>
      <Grid
        item
        xs={12}
        pr={'0 !important'}
        mt={{
          xs: '20px',
        }}
        pt={'0 !important'}
      >
        <ComparisonChart
          sources={['IME_AVG_BID_PRICE', 'IME_AVG_ASK_PRICE', 'ESTJ']}
          title="نمودار بورس کالا و اتحادیه"
          hideWeightInput
        />
      </Grid>
    </>
  );
};

export default Charts;
